<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBaseMaster from '../TableRowBase.vue';

  export default {
    name: 'TableRowBase',
    extends: TableRowBaseMaster,
    props: {
      title: {
        default: null,
      }
    },
    computed: {
      displayTitle() {
        return this.title || 'Monthly';
      },
    },
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'number_audiograms', throughMonth),
          2 * this.getYtdByField(yearObj, 'number_physicians', throughMonth),
        );
      },
    },
  };
</script>
